// extracted by mini-css-extract-plugin
export default {"wrapper":"Wn-z","response":"Xn-z","error":"Yn-z","disabled":"Zn-z","buttons":"_n-z","feedbackQuestionSection":"ao-z","yesNoWrapper":"bo-z"};